/**
 * Billable Icon Component
 * Renders billable/non-billable icon based on billable status
 */

import React from "react";

const BillableIcon = ({ billable, className = "", onClick }) => {
  return (
    <div className="billable-section" onClick={onClick} style={onClick ? { cursor: 'pointer' } : {}}>
      <div className={`billable-timing-sec ${billable ? "billable-timing" : "non-billable-timing"} ${className}`}>
        <svg
          width="13"
          height="20"
          viewBox="0 0 13 20"
          fill={billable ? "#405BFF" : "none"}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.544 19.32V17.4C3.264 17.184 1.464 16.2 0.024 14.688L1.872 12.792C3.288 14.232 4.848 14.952 6.648 14.904C8.304 14.88 9.408 14.232 9.408 13.176C9.408 11.808 8.064 11.664 5.616 11.04C3.336 10.464 0.384 9.72 0.384 6.792C0.384 4.32 2.736 2.568 5.592 2.376V0.503999H7.248V2.424C9.024 2.64 10.776 3.408 12.192 4.848L10.368 6.744C8.952 5.448 7.704 4.8 6.072 4.8C4.32 4.8 3.168 5.424 3.168 6.48C3.168 7.656 4.464 8.064 6.936 8.592C9.24 9.12 12.384 9.768 12.384 12.888C12.384 15.6 10.08 17.184 7.2 17.4V19.32H5.544Z"
            fill="#96A8BA"
          />
        </svg>
      </div>
    </div>
  );
};

export default BillableIcon;
